import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../../assets/css/auth.css';
import logo from '../../assets/images/logo.png';
import { ForgotPasswordApi } from '../../Redux/Auth/Auth_Action';

const ForgotPassword = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [state, setState] = useState("");
    // console.log("forgot password", state);

    const SubmitData = (e) => {
        e.preventDefault();
        let forgotPasswordEmail = { email: state }
        dispatch(ForgotPasswordApi(forgotPasswordEmail))
            .then((res) => {
                toast.success("Reset password link has been sent to your email address");
                navigate('/signin');
            })
            .catch((e) => {
                console.log("error from forgot password page", e)
            })
    }

    return (
        <div className='authentication forgotpassword'>
            <div className='auth-box-container'>
                <div className='auth-box'>
                    <form>
                        <div className='row'>
                            <div className='col-lg-12 pt-3 mb-4 text-center'>
                                <img className='logo-top mt-5' src={logo} />
                            </div>
                            <div className='col-lg-12 mt-4 text-center'>
                                <p className='f-mon-bold f-45 mb-3 mt-5'>Forgot Password</p>
                                <p className='mb-0 f-28 f-mon-reg mb-5'>Please Enter Your <span className='f-mon-bold'>Email Below</span> </p>
                                <input required type='text' onChange={(e) => { setState(e.target.value); }} placeholder='Email' className="form-control f-16 f-mon-reg mt-4 rounded-0 inpt-fld-auth" />
                            </div>
                            <div className='col-lg-12 mt-4'>
                                <button onClick={SubmitData} className='btn btn-light form-control bt-auth'>SUBMIT</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword;